import { Injectable }    from '@angular/core';
import { environment } from 'src/environments/environment';
import { SupplierRoundListModel, SupplierRoundSelectedOffer } from 'src/common';
import {SearchModel, SearchResultModel} from 'src/common';
import {HttpClient} from '@angular/common/http';



const localApiUrl = `${environment.apiUrl}/SupplierRound`;

@Injectable()
export class SupplierRoundListService {

  constructor(private http: HttpClient) { }

  search(search: SearchModel): Promise<SearchResultModel<SupplierRoundListModel>> {
      return this.http.post<SearchResultModel<SupplierRoundListModel>>(`${localApiUrl}/Search`, search).toPromise();
  }

  getAll(): Promise<SupplierRoundListModel[]> {
	return this.http.get<SupplierRoundListModel[]>(`${localApiUrl}/All`).toPromise();
  }

  getById(id: number): Promise<SupplierRoundListModel> {
    return this.http.get<SupplierRoundListModel>(`${localApiUrl}/Details/${id}`).toPromise();
  }

  delete(id: number): Promise<void> {
	return this.http.get<void>(`${localApiUrl}/Delete/${id}`).toPromise();
  }

  save(model: any): Promise<void> {
    return this.http.post<void>(`${localApiUrl}/Save`, model).toPromise();
  }

  getSupplierRoundSelectedOffers (id: number): Promise<SupplierRoundSelectedOffer[]> {
    return this.http.post<SupplierRoundSelectedOffer[]>(`${localApiUrl}/GetSupplierRoundSelectedOffers/${id}`, '').toPromise();
  }

  changeStatus(model: any): Promise<void> {
    return this.http.post<void>(`${localApiUrl}/ChangeStatus`, model).toPromise();
  }
}



